import type LogRocket from "logrocket";

type Recorder = typeof LogRocket;
type Traits = Record<string, string | number | boolean>;

let recorder: Recorder | null = null;

export const startLogRocket = async (
  appId: string,
  userId: string,
  traits: Traits,
) => {
  if (recorder) return;
  const { default: loaded } = await import("logrocket");
  loaded.init(appId);
  loaded.identify(userId, traits);
  recorder = loaded;
};

export const trackLogRocket = (event: string) => {
  recorder?.track(event);
};
